export enum Tenant {
    ES_EOS = "es-eos",
    BE_EOS = "be-eos",
    DE_DID = "de-did",
    FR_EOS = "fr-eos",
    CH_EOS = "ch-eos",
    UDP_MOCK = "udp-mock",
}
